import React from 'react';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';

import ToggleMenu from './ToggleMenu';
import ContactTag from '../ContactTag';

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }
  closeMenu = () => {
    this.setState({
      menuActive: false,
    });
  }

  render() {
    const { menuActive, className } = this.state;
    return (
      <div className={`${className || 'header d-flex justify-content-between align-items-center'}`}>
        <ContactTag />
        <div className="Header_logo">
          <Link name="index">
            <img src="/images/70west-header-logo.svg" alt="70 West Builders Logo" className="logo" />
          </Link>
        </div>
        <button className="Header_menuToggle" onClick={this.toggleMenu} />
        <ul className="nav justify-content-end">
          <li className="nav-item">
            <Link name="communities" className="nav-link active">Find Your Home</Link>
          </li>
          <li className="nav-item">
            <Link name="building-process" className="nav-link active">Homebuying Guide</Link>
          </li>
          <li className="nav-item">
            <Link name="difference" className="nav-link active">About Us</Link>
          </li>
          <li className="nav-item">
            <Link name="contact-us" className="nav-link" href="">Contact Us</Link>
          </li>
        </ul>
        <ToggleMenu isActive={menuActive} toggleMenu={this.toggleMenu} />
      </div>
    );
  }
}

export default withData({
  areas: true,
})(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js